const PlayIcon = () => (
  <svg viewBox="0 0 24 24" className="h-5 w-5 shrink-0" aria-hidden="true">
    <path fill="#00D7FE" d="M3.6 1.8 13.4 12 3.6 22.2c-.4-.2-.6-.7-.6-1.2V3c0-.5.2-1 .6-1.2z" />
    <path fill="#00F076" d="m16.8 8.6-3.4 3.4-9.8-10.2c.3-.2.8-.2 1.2 0z" />
    <path fill="#FF3A44" d="m16.8 15.4-12 6.8c-.4.2-.9.2-1.2 0l9.8-10.2z" />
    <path fill="#FFD500" d="M20.4 10.5c.8.5.8 1.6 0 2.1l-3.6 2.8-3.4-3.4 3.4-3.4z" />
  </svg>
);

const AppleIcon = () => (
  <span className="grid h-7 w-7 shrink-0 place-items-center rounded-full bg-white" data-testid="appstore-icon">
    <svg viewBox="0 0 24 24" className="h-4 w-4" aria-hidden="true">
      <path fill="#000" d="M12.152 6.896c-.948 0-2.415-1.078-3.96-1.04-2.04.027-3.91 1.183-4.961 3.014-2.117 3.675-.546 9.103 1.519 12.09 1.013 1.454 2.208 3.09 3.792 3.039 1.52-.065 2.09-.987 3.935-.987 1.831 0 2.35.987 3.96.948 1.637-.026 2.676-1.48 3.676-2.948 1.156-1.688 1.636-3.325 1.662-3.415-.039-.013-3.182-1.221-3.22-4.857-.026-3.04 2.48-4.494 2.597-4.559-1.429-2.09-3.623-2.324-4.39-2.376-2-.156-3.675 1.09-4.61 1.09zM15.53 3.83c.843-1.012 1.4-2.427 1.245-3.83-1.207.052-2.662.805-3.532 1.818-.78.896-1.454 2.338-1.273 3.714 1.338.104 2.715-.688 3.559-1.701" />
    </svg>
  </span>
);

const STORES = {
  playstore: { label: "Google Play", Icon: PlayIcon },
  appstore: { label: "App Store", Icon: AppleIcon },
};

const STYLES = {
  dark: { on: "border-white/20 text-paper hover:border-volt", off: "border-white/10 text-zinc-400", sub: "text-zinc-400" },
  volt: { on: "border-ink bg-ink text-paper hover:scale-[1.04]", off: "border-ink/40 text-ink", sub: "opacity-70" },
};

export const storeLink = (settings, key) => (settings?.[`${key}_enabled`] && settings?.[`${key}_url`] ? settings[`${key}_url`] : null);

export const StoreButton = ({ store, settings, variant = "dark", testId }) => {
  const { label, Icon } = STORES[store];
  const href = storeLink(settings, store);
  const s = STYLES[variant];
  const base = "flex items-center gap-2.5 rounded-full border px-4 py-3 transition-[transform,border-color] duration-300 sm:px-6";
  const text = (
    <span className="text-left leading-tight">
      <span className={`block text-[11px] uppercase tracking-wider ${s.sub}`}>{href ? "Download di" : label}</span>
      <span className="block font-semibold">{href ? label : "Segera hadir"}</span>
    </span>
  );
  return href ? (
    <a data-testid={testId} href={href} target="_blank" rel="noreferrer" className={`${base} ${s.on}`}><Icon />{text}</a>
  ) : (
    <div data-testid={`${testId}-soon`} aria-disabled="true" className={`${base} cursor-not-allowed ${s.off}`}><Icon />{text}</div>
  );
};

export const StoreButtons = ({ settings, variant, prefix }) => (
  <div className="flex flex-wrap gap-3">
    <StoreButton store="playstore" settings={settings} variant={variant} testId={`${prefix}-playstore`} />
    <StoreButton store="appstore" settings={settings} variant={variant} testId={`${prefix}-appstore`} />
  </div>
);
